export default {
      id: "create-report-usage",
      viewBox: "0 0 19 20",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#create-report",
      toString: function () {
        return this.url;
      }
    }